// extracted by mini-css-extract-plugin
module.exports = {"button":"mobileAsideWrapper_button__Eq3lN","aside":"mobileAsideWrapper_aside___TTri"};